<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-100" style="padding-bottom:20px;">
     <md-card >
        <md-card-content>
         <div class="md-layout">
           <div class="md-layout-item md-size-90">
             <md-progress-bar class="dataprogress" md-mode="buffer" :md-value="percent_complete" :md-buffer="percent_checkedout"></md-progress-bar>
             <span>{{nComplete}}/{{nTotal}}</span>
           </div>
           <div class="md-layout-item md-size-10">
             <md-button v-on:click="nextImage()" class="nextimage">Next Image<md-icon>navigate_next</md-icon></md-button>
           </div>
         </div>
        </md-card-content>
     </md-card>
    </div>

    <div class="md-layout-item md-size-100">
     <labelimage :dataset="dataset" :image="image" ref="labelimage">
     </labelimage>
    </div>
 </div>
</template>

<script>

import LabelImage from '@/components/LabelImage'

function unique (b, c) {
  console.log('here')
  var a = b.concat(c)
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i].Image === a[j].Image && a[i].Dataset === a[j].Dataset) {
        a.splice(j--, 1)
      }
    }
  }
  console.log('Done', a)
  return a
}

export default {
  name: 'job',
  props: ['dataset'],
  data: () => ({
    shownavigation: false,
    showsidepanel: false,
    nComplete: 0,
    nTotal: 0,
    nCheckedout: 0,
    image: '',
    checkedout: []

  }),
  computed: {
    percent_complete: function () {
      if (this.nTotal <= 0) return 0
      console.log('Complete', 100 * this.nComplete / this.nTotal)
      return 100 * this.nComplete / this.nTotal
    },
    percent_checkedout: function () {
      if (this.nTotal <= 0) return 0
      console.log('Checkedout', 100 * this.nCheckedout / this.nTotal)
      return this.percent_complete + 100 * this.nCheckedout / this.nTotal
    }
  },
  methods: {
    percent: function (job) {
      return 100 * job.completed / job.total
    },
    checkoutImages: function () {
      var self = this
      return new Promise((resolve, reject) => {
        self.$auth.loaded().then(function () {
          self.axios.get(`/api/dataset/${self.dataset}/checkoutimages`,
            {headers: { Authorization: `Bearer ${self.$auth.getAccessToken()}` }})
            .then(response => {
              self.nTotal = response.data.dataset.total
              self.nComplete = response.data.dataset.completed
              self.nCheckedout = response.data.dataset.checkedout
              self.checkedout = unique(self.checkedout, response.data.labels)
              resolve(self.checkedout)
              if (self.checkedout.length === 0) {
                console.info('Must be done with the dataset')
                return // TODO: All done with dataset
              }
              self.image = self.checkedout[0].Image
            }).catch(e => {
              console.error(e)
              reject(e)
            })
        })
      })
    },
    nextImage: function () {
      var self = this
      var il = this.$refs.labelimage
      if (!il.isLabeled()) return
      self.$root.loading++
      il.recordLabel().then(function () {
        self.nComplete++
        self.nCheckedout--
        self.$root.loading--
        if (self.checkedout.length <= 1) {
          return // TODO: All done!
        }
        if (self.checkedout.length < 5) {
          self.checkoutImages()
        }
        self.checkedout.shift()
        self.image = self.checkedout[0].Image
      }).catch(function (e) {
        console.error(e)
      })
    },
    keypress: function (e) {
      if (e.key === 'ArrowRight') {
        this.nextImage()
      }
    }
  },
  components: {
    'labelimage': LabelImage
  },
  mounted () {
    var self = this
    this.$root.loading = 1
    this.checkoutImages().then(function () {
      self.$root.loading--
    })
  },
  created () {
    window.addEventListener('keydown', this.keypress)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keypress)
  }
}
</script>

<style>
.dataprogress .md-progress-bar-buffer {
  border-color: rgba(68,138,255,0.1) !important;
  animation: f 10s infinite linear !important;
}
.nextimage {
  margin: 0;
  float: right;
  margin-top: -10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Job.vue